import React, { useState, useEffect } from 'react';

/**
 * Loading bubble with progressive status messages.
 * Shows different status text as time passes.
 */
export const LoadingBubble: React.FC<{ streamingStatus?: string | undefined }> = ({ streamingStatus }) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setElapsed(s => s + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  let statusText = streamingStatus || 'Analyzing...';
  if (!streamingStatus) {
    if (elapsed >= 60) {
      statusText = 'Almost there — generating comprehensive response...';
    } else if (elapsed >= 30) {
      statusText = 'Processing large content — hang tight...';
    } else if (elapsed >= 10) {
      statusText = 'Still working — reading through the content...';
    }
  }

  return (
    <div className="flex justify-start">
      <div className="bg-slate-100 rounded-2xl rounded-bl-md px-4 py-3 max-w-[85%]">
        <div className="flex items-center gap-2 text-slate-500">
          <div className="flex gap-1">
            <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          <span className="text-sm">{statusText}</span>
        </div>
      </div>
    </div>
  );
};
